import { topicItems } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500">漫画社区热议话题，加入讨论发现同好</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href="#comments"
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-full hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}